export default __webpack_public_path__ + "static/shield-columbia-170644cbd008c550bad27f8b8ad69be9.svg";